var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.selectedDiv === "Preapproved Invoice" ||
              _vm.selectedDiv === "All",
            expression:
              "selectedDiv === 'Preapproved Invoice' || selectedDiv === 'All'",
          },
        ],
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-12 mt-2 px-4" }, [
            _c("div", { staticClass: "card dashboard-card" }, [
              _c("div", { staticClass: "graph-body" }, [
                _c(
                  "div",
                  { staticClass: "card-body col-md-12 col-lg-12 col-xl-10" },
                  [
                    _c("div", { staticClass: "card-header" }, [
                      _c("h6", [
                        _c("i", {
                          staticClass: "fa fa-line-chart text-primary",
                        }),
                        _vm._v(
                          _vm._s(_vm.$tc("Preapproved Invoices", 2)) + " "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "year-selector" },
                        [
                          _c("base-select", {
                            attrs: {
                              options: _vm.getFunders,
                              searchable: true,
                              "show-labels": false,
                              "allow-empty": true,
                              tabindex: 8,
                              placeholder: _vm.$t("dashboard.select_funder"),
                              label: "name",
                              "track-by": "id",
                            },
                            model: {
                              value: _vm.selectedFunder,
                              callback: function ($$v) {
                                _vm.selectedFunder = $$v
                              },
                              expression: "selectedFunder",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _vm.isLoaded
                        ? _c(
                            "div",
                            { staticClass: "col-md-6" },
                            [
                              _c("bar-chart", {
                                ref: "chart",
                                attrs: {
                                  label: "Invoices",
                                  labels: _vm.labels,
                                  values: [].concat(
                                    _vm.preapprovedInvoiceGroupCount
                                  ),
                                  "background-color": _vm.bgColors,
                                  "border-color": _vm.bgColors,
                                  "hover-background-color": _vm.bgColors,
                                  "hover-border-color": _vm.bgColors,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-6" },
                        [
                          _c("p", { staticClass: "text-center" }, [
                            _vm._v(" Total Credit Limit "),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$utils.formatMoney(
                                    _vm.total_credit_limit,
                                    _vm.defaultCurrency
                                  )
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _vm.isLoaded
                            ? _c("pie-chart", {
                                attrs: {
                                  labels: _vm.CrditLimitLabels,
                                  values: _vm.CreditLimitData,
                                  "bg-colors": _vm.CreditLimitBgColors,
                                  "hover-bg-colors": _vm.hoverBgColors,
                                  type: "pie",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _c("h6", { staticClass: "title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("dashboard.total_amount_financed")) +
                            " "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.isLoaded
                        ? _c("span", { staticClass: "total" }, [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$utils.formatMoney(
                                    _vm.financedAmount,
                                    _vm.defaultCurrency
                                  )
                                ),
                              },
                            }),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "chart-desc col-md-12 col-lg-12 col-xl-2" },
                  [
                    _c("div", { staticClass: "stats" }, [
                      _c("div", { staticClass: "description" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("dashboard.invoice_chart.pending")
                              ) +
                              " "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _vm.isLoaded
                          ? _c(
                              "span",
                              {
                                staticClass: "total",
                                staticStyle: { color: "#334CFF" },
                              },
                              [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.preapprovedInvoiceGroupCount[0]
                                    ),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "description" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("dashboard.invoice_chart.offered")
                              ) +
                              " "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _vm.isLoaded
                          ? _c(
                              "span",
                              {
                                staticClass: "total",
                                staticStyle: { color: "#E333FF" },
                              },
                              [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.preapprovedInvoiceGroupCount[1]
                                    ),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "description" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("dashboard.invoice_chart.financed")
                              ) +
                              " "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _vm.isLoaded
                          ? _c(
                              "span",
                              {
                                staticClass: "total",
                                staticStyle: { color: "#33FF71" },
                              },
                              [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.preapprovedInvoiceGroupCount[2]
                                    ),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "description" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("dashboard.invoice_chart.prepaid")
                              ) +
                              " "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _vm.isLoaded
                          ? _c(
                              "span",
                              {
                                staticClass: "total",
                                staticStyle: { color: "#F9FF33" },
                              },
                              [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.preapprovedInvoiceGroupCount[3]
                                    ),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "description" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("dashboard.invoice_chart.settlement")
                              ) +
                              " "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _vm.isLoaded
                          ? _c(
                              "span",
                              {
                                staticClass: "total",
                                staticStyle: { color: "#FFB233" },
                              },
                              [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.preapprovedInvoiceGroupCount[4]
                                    ),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "description" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("dashboard.invoice_chart.rejected")
                              ) +
                              " "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _vm.isLoaded
                          ? _c(
                              "span",
                              {
                                staticClass: "total",
                                staticStyle: { color: "#FF3F33" },
                              },
                              [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.preapprovedInvoiceGroupCount[5]
                                    ),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "description" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("dashboard.invoice_chart.total_invoice")
                              ) +
                              " "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _vm.isLoaded
                          ? _c("span", { staticClass: "total" }, [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.totalpreapprovedinvoiceGroup
                                  ),
                                },
                              }),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.selectedDiv === "Preapproved Invoice" ||
              _vm.selectedDiv === "All",
            expression:
              "selectedDiv === 'Preapproved Invoice' || selectedDiv === 'All'",
          },
        ],
        staticClass: "row table-row",
      },
      [
        _c("div", { staticClass: "col-lg-12 col-xl-4 mt-2 px-4" }, [
          _c(
            "div",
            { staticClass: "table-header" },
            [
              _c("h6", { staticClass: "table-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("dashboard.due_invoices_card.title")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                { attrs: { to: "/supplier/invoices" } },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "btn-sm",
                      attrs: { outline: true, color: "theme" },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("dashboard.due_invoices_card.view_all")
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dashboard-table" },
            [
              _c(
                "table-component",
                {
                  ref: "inv_table",
                  staticClass: "dashboard",
                  attrs: {
                    data: _vm.getDueInvoices,
                    "show-filter": false,
                    "table-class": "table",
                  },
                },
                [
                  _c("table-column", {
                    attrs: {
                      label: _vm.$t("dashboard.due_invoices_card.due_on"),
                      show: "formattedDueDate",
                    },
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: { label: _vm.$t("invoices.customer") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (row) {
                          return [
                            row.buyer_stakeholder
                              ? _c("p", [
                                  row.customer.parent_account_id &&
                                  row.buyer_stakeholder.details.company &&
                                  row.buyer_stakeholder.details.company.name
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              row.buyer_stakeholder.details
                                                .company.name
                                            ) +
                                            "\n                "
                                        ),
                                      ])
                                    : row.customer.parent_account_id == null
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              row.buyer_stakeholder.details.user
                                                .name
                                            ) +
                                            "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: {
                      label: _vm.$t("invoices.status"),
                      "sort-as": "status",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (row) {
                          return [
                            _c("span", [
                              _vm._v(" " + _vm._s(_vm.$t("invoices.status"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                class: "inv-status-" + row.status.toLowerCase(),
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    row.status != "PARTIALLY_PAID"
                                      ? row.status
                                      : row.status.replace("_", " ")
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: {
                      label: _vm.$t("dashboard.due_invoices_card.amount_due"),
                      show: "due_amount",
                      "sort-as": "due_amount",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (row) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "dashboard.due_invoices_card.amount_due"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$utils.formatMoney(
                                    row.due_amount,
                                    row.customer.currency
                                  )
                                ),
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: {
                      sortable: false,
                      filterable: false,
                      "cell-class":
                        "action-dropdown dashboard-recent-invoice-options no-click",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (row) {
                          return [
                            _c(
                              "v-dropdown",
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: { slot: "activator", href: "#/" },
                                    slot: "activator",
                                  },
                                  [_c("dot-icon")],
                                  1
                                ),
                                _vm._v(" "),
                                row.status == "DRAFT"
                                  ? _c(
                                      "v-dropdown-item",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "dropdown-item",
                                            attrs: {
                                              to: {
                                                path:
                                                  "invoices/" +
                                                  row.id +
                                                  "/edit",
                                              },
                                            },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass: "dropdown-item-icon",
                                              attrs: {
                                                icon: ["fas", "pencil-alt"],
                                              },
                                            }),
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(_vm.$t("general.edit")) +
                                                "\n                  "
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-dropdown-item",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: {
                                          to: {
                                            path:
                                              "invoices/" + row.id + "/view",
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "dropdown-item-icon",
                                          attrs: { icon: "eye" },
                                        }),
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.$t("invoices.view")) +
                                            "\n                  "
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                row.status == "DRAFT"
                                  ? _c("v-dropdown-item", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#/" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.sendInvoice(row)
                                            },
                                          },
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass: "dropdown-item-icon",
                                            attrs: { icon: "envelope" },
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t("invoices.send_invoice")
                                              ) +
                                              "\n                  "
                                          ),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-12 col-xl-4 mt-2 mob-table" }, [
          _c(
            "div",
            { staticClass: "table-header" },
            [
              _c("h6", { staticClass: "table-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("dashboard.offer_invoices_card.title")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                { attrs: { to: "/supplier/invoices" } },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "btn-sm",
                      attrs: { outline: true, color: "theme" },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("dashboard.offer_invoices_card.view_all")
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dashboard-table" },
            [
              _c(
                "table-component",
                {
                  ref: "inv_table",
                  staticClass: "dashboard",
                  attrs: {
                    data: _vm.getOfferInvoices,
                    "show-filter": false,
                    "table-class": "table",
                  },
                },
                [
                  _c("table-column", {
                    attrs: {
                      label: _vm.$t("dashboard.offer_invoices_card.due_on"),
                      show: "formattedDueDate",
                    },
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: { label: _vm.$t("invoices.customer") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (row) {
                          return [
                            row.buyer_stakeholder
                              ? _c("p", [
                                  row.customer.parent_account_id &&
                                  row.buyer_stakeholder.details.company &&
                                  row.buyer_stakeholder.details.company.name
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              row.buyer_stakeholder.details
                                                .company.name
                                            ) +
                                            "\n                "
                                        ),
                                      ])
                                    : row.customer.parent_account_id == null
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              row.buyer_stakeholder.details.user
                                                .name
                                            ) +
                                            "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: {
                      label: _vm.$t("invoices.status"),
                      "sort-as": "status",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (row) {
                          return [
                            _c("span", [
                              _vm._v(" " + _vm._s(_vm.$t("invoices.status"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                class: "inv-status-" + row.status.toLowerCase(),
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    row.status != "PARTIALLY_PAID"
                                      ? row.status
                                      : row.status.replace("_", " ")
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: {
                      label: _vm.$t("dashboard.offer_invoices_card.amount"),
                      show: "due_amount",
                      "sort-as": "due_amount",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (row) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("dashboard.offer_invoices_card.amount")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$utils.formatMoney(
                                    row.nominal_amount,
                                    row.customer.currency
                                  )
                                ),
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: {
                      sortable: false,
                      filterable: false,
                      "cell-class":
                        "action-dropdown dashboard-recent-invoice-options no-click",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (row) {
                          return [
                            _c(
                              "v-dropdown",
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: { slot: "activator", href: "#/" },
                                    slot: "activator",
                                  },
                                  [_c("dot-icon")],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-dropdown-item",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: {
                                          to: {
                                            path:
                                              "invoices/" + row.id + "/view",
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "dropdown-item-icon",
                                          attrs: { icon: "eye" },
                                        }),
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.$t("invoices.view")) +
                                            "\n                  "
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                row.pre_pay == 1 &&
                                row.request_level == "Offered"
                                  ? _c("v-dropdown-item", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#/" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.viewOffer(row.id)
                                            },
                                          },
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass: "dropdown-item-icon",
                                            attrs: { icon: ["far", "comment"] },
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t("invoices.view_offer")
                                              ) +
                                              "\n                  "
                                          ),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-12 col-xl-4 mt-2" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dashboard-table" },
            [
              _c(
                "table-component",
                {
                  ref: "inv_table",
                  staticClass: "dashboard",
                  attrs: {
                    data: _vm.getRateOfPrePayment,
                    "show-filter": false,
                    "table-class": "table",
                  },
                },
                [
                  _c("table-column", {
                    attrs: { label: "Funder", show: "name" },
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: { label: "Spread" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (row) {
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(parseFloat(row.value).toFixed(2)) +
                                "%\n            "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: { label: "Kibor" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (row) {
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(Number(row.kibor_amount).toFixed(2)) +
                                "%\n            "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: { label: "Rate of Prepayment" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (row) {
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  (
                                    Number(row.value) + Number(row.kibor_amount)
                                  ).toFixed(2)
                                ) +
                                "%\n            "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table-header" }, [
      _c("h6", { staticClass: "table-title" }, [
        _vm._v("\n          Rate of Pre-Payment\n        "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }